// extracted by mini-css-extract-plugin
export default {"filtersContainer":"DocumentsWebFilter_filtersContainer__rk3Lf","dateField":"DocumentsWebFilter_dateField__1ub74","dropdownField":"DocumentsWebFilter_dropdownField__3kRJx"};